import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';

import { TileCard } from './TileCard.jsx';
import { parseDate } from '../../utils/helpers';

export const Post = ({
  publishDate,
  campaignId,
  tiles,
  campaignTiles,
  postIndex,
  status,
}) => {
  const { t } = useTranslation('posts');

  return (
    <Container>
      <Header>
        <Text variant="subtitle1" mr="5px">
          {t('preview.tileCount', { tileCount: tiles.length })}
        </Text>
        <Status>{status}</Status>
        <Text>
          {t('preview.for')}
          {parseDate(publishDate, t('unscheduledPost'))}
        </Text>
      </Header>
      <Tiles>
        {campaignTiles.map((tile, index) => (
          <TileCard
            key={tile.id}
            tile={{ ...tile, index }}
            index={index}
            campaignId={campaignId}
            isNew={tiles.includes(tile)}
            postIndex={postIndex}
            postStatus={status}
          />
        ))}
      </Tiles>
    </Container>
  );
};

const Status = styled(Text)`
  text-transform: capitalize;
  display: inline-block;
`;

const Tiles = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 174px);
  column-gap: 30px;
  row-gap: 20px;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  margin: 0 20px;
  padding: 20px 0;
`;
